import { FAMILY_FILE_TYPES } from 'services/family.service';
import { FAMILY_BRANCH_MAP } from '../../familyApplicationConstants';

export const CHILD_CYS_LINKS = [
  {
    name: 'Anniston Army Depot',
    link: 'https://maps.app.goo.gl/HRj3FqKkGmBYy2V68',
  },
  {
    name: 'Carlisle Barracks',
    link: 'https://maps.app.goo.gl/pHAn49yonq3U3q3f9',
  },
  {
    name: 'Detroit Arsenal',
    link: 'https://maps.app.goo.gl/xUfUbfQdjf2uC2P97',
  },
  {
    name: 'Dugway Proving Ground',
    link: 'https://maps.app.goo.gl/nsHR7LVT8Xbno5hB8',
  },
  {
    name: 'Fort Bliss',
    link: 'https://maps.app.goo.gl/m9FirfPkMhhsPc1y8',
  },
  {
    name: 'Fort Bliss (Entrance 2)',
    link: 'https://maps.app.goo.gl/eoQXEaZy63qQLT3T7',
  },
  {
    name: 'Fort Buchanan',
    link: 'https://maps.app.goo.gl/8SPnKfQ8GUnesHAB6',
  },
  {
    name: 'Fort Greely',
    link: 'https://maps.app.goo.gl/tBs6GSgZTXJ8UFN88',
  },
  {
    name: 'Fort Hamilton',
    link: 'https://maps.app.goo.gl/4QRLuPhQeuzPJSE8A',
  },
  {
    name: 'Fort Huachuca',
    link: 'https://maps.app.goo.gl/sWgBA9ZiEufkruEq6',
  },
  {
    name: 'Fort Hunter Liggett',
    link: 'https://maps.app.goo.gl/rDqRoemyor4DKzxj6',
  },
  {
    name: 'Fort Jackson',
    link: 'https://maps.app.goo.gl/91iwssVaXzBaBQGf7',
  },
  {
    name: 'Fort Knox',
    link: 'https://maps.app.goo.gl/JYnqmxNSCnZZTUxt7',
  },
  {
    name: 'Fort Leavenworth',
    link: 'https://maps.app.goo.gl/T9VHPx62mfNuoexu8',
  },
  {
    name: 'Fort Lee',
    link: 'https://maps.app.goo.gl/wYoUjCzgDv9YXTh46',
  },
  {
    name: 'Fort Leonard Wood',
    link: 'https://maps.app.goo.gl/9Ycmwi54EUhmpNsC7',
  },
  {
    name: 'Fort McCoy',
    link: 'https://maps.app.goo.gl/GsMqbQKFQXNre5mq5',
  },
  {
    name: 'Fort Polk North',
    link: 'https://maps.app.goo.gl/4XVaoCh6LXskb9Mk9',
  },
  {
    name: 'Fort Polk South',
    link: 'https://maps.app.goo.gl/QEsaMS1btgMZ3wbWA',
  },
  {
    name: 'Fort Riley',
    link: 'https://maps.app.goo.gl/XJhXcMeornJgvjqW8',
  },
  {
    name: 'Fort Rucker',
    link: 'https://maps.app.goo.gl/nztysGrUAaZ5nFsj8',
  },
  {
    name: 'Fort Sill',
    link: 'https://maps.app.goo.gl/DMTS7gT2QbRuYnjHA',
  },
  {
    name: 'Letterkenny Army Depot',
    link: 'https://maps.app.goo.gl/ngbGHbBBfSA4vVPz9',
  },
  {
    name: 'McAlester Army Depot',
    link: 'https://maps.app.goo.gl/rDcaRyFwxAVTayxd8',
  },
  {
    name: 'Picatinny Arsenal',
    link: 'https://maps.app.goo.gl/WFoyhfBH8YWpzWQo7',
  },
  {
    name: 'Pine Bluff Arsenal',
    link: 'https://maps.app.goo.gl/jhnWs6JQASWjTT8YA',
  },
  {
    name: 'Presidio of Monterey',
    link: 'https://maps.app.goo.gl/44V5hAepevaRpSZTA',
  },
  {
    name: 'Redstone Arsenal',
    link: 'https://maps.app.goo.gl/Fsq3ShBcoNqPHsBp8',
  },
  {
    name: 'Rock Island Arsenal',
    link: 'https://maps.app.goo.gl/SgQXwdV7aKokKxvi8',
  },
  {
    name: 'Sierra Army Depot',
    link: 'https://maps.app.goo.gl/gzsyZLrsDwbzC2kw5',
  },
  {
    name: 'Southern Command',
    link: 'https://maps.app.goo.gl/SCJ9NYwjejQC979D8',
  },
  {
    name: 'Tobyhanna Army Depot',
    link: 'https://maps.app.goo.gl/12AXhR6RfTR8bE5p8',
  },
  {
    name: 'USAG Miami',
    link: 'https://maps.app.goo.gl/TTAKeBvoDCYiqC289',
  },
  {
    name: 'White Sands Missile Range',
    link: 'https://maps.app.goo.gl/XAxAfg7i7oCemACv7',
  },
  {
    name: 'Yuma Proving Ground',
    link: 'https://maps.app.goo.gl/Lo3bavAUuD2SHZPn9',
  },
];

export function getChildFormTemplateDownloadLink(fileType, branchId) {
  if (fileType === FAMILY_FILE_TYPES.CHILD_CYS?.code) {
    return 'https://info.childcareaware.org/hubfs/Statement%20of%20Non-Availability%20%5BFillableNov2024%5D.pdf';
  } else if (fileType === FAMILY_FILE_TYPES.PROVIDER_RATES?.code) {
    // if Branch if army
    if (branchId === FAMILY_BRANCH_MAP.army.id) {
      return 'https://www.childcareaware.org/wp-content/uploads/2021/03/3.25.20-PCVF.pdf';
    } else {
      return 'https://info.childcareaware.org/hubfs/AFMC%20Provider%20Cost%20Verification%20Form_Apr2024%203.pdf';
    }
  }
}
